export default __webpack_public_path__ + "static/media/mall-hall.a26a4d55.svg";